<template>
  <tr :class="['table_tr',item_info.from_type == 1?'table_tr_1':'']" @click="toDetail(item_info)">
     <template  v-if="item_info.rank_type == 'brand' || item_info.rank_type == 'serie' || item_info.rank_type == 'province' || item_info.rank_type == 'enterprise'">
        <td class="ranking_td">
            <template v-if="item_info.ind>3">
                <div class="ranking">
                    {{item_info.ind}}
                </div>
            </template>
            <template v-else>
                <div :class="['ranking','ranking'+item_info.ind]"></div>
            </template>
        </td>
        <td class="td_hover" v-if="item_info.rank_type == 'enterprise'">{{item_info.data.enterprise}}</td>
        <template v-if="item_info.rank_type == 'brand'">
            <template v-if="item_info.rank_type == 'brand'">
                <td class="td_hover">{{item_info.data.brand_name}}</td>
            </template>
            <template v-else>
                <td>{{item_info.data.brand_name}}</td>
            </template>
        </template>
        <td class="td_hover" v-if="item_info.rank_type == 'serie'">{{item_info.data.serie_name}}</td>
        <template v-if="item_info.rank_type == 'province'">
            <td style="white-space:nowrap;" class="td_hover">{{item_info.data.province}}</td>
        </template>
        <!-- <template v-else>
            <td style="white-space:nowrap;">{{item_info.data.province}}</td>
        </template> -->
        <td class="font_bold">
            {{formatNum(item_info.data.total_smart_sales)}}
        </td>
        <td class="font_bold">
            {{formatNum(item_info.data.total_sales)}}
        </td>
    </template>
    <template v-else>
        <td>
            <div class="td_flex">
                <div class="td_color"></div>
                <div class="td_name">
                    {{item_info.data.model_name}}
                </div>
            </div>
        </td>
        <td>
            {{item_info.m_province}}
        </td>
        <td class="font_bold">
            {{(item_info.data.total_smart_sales/item_info.sum*100).toFixed(2)}}%
        </td>
    </template>
    <td v-if="item_info.energy_obj && item_info.energy_obj.val==2 && rank_type=='serie'">
        {{item_info.data.min_price>0?item_info.data.min_price+'万起':'-'}}
    </td>
    <td>
        <div class="rank_change" v-if="item_info.data.rank_change>0">
            <div class="icon_up"></div>{{item_info.data.rank_change}}
        </div>
        <div class="rank_change" v-else-if="item_info.data.rank_change<0">
            <div class="icon_down"></div>{{Math.abs(item_info.data.rank_change)}}
        </div>
        <div class="rank_change" v-else>
            -
        </div>
    </td>
    <td :class="['td_chart',item_info.from_type == 1?'td_chart_1':'']">
        <!-- <div class="item_echart" ref="itemChart"> </div>-->
        <div :class="['item_echart',item_info.from_type == 1?'item_echart_1':'']">
            <template v-if="xAxis_data && series_data">
                <LineChart
                    :opts="{xAxis_data,series_data}"
                />
            </template>
        </div>

    </td>
  </tr>
</template>

<script>
import LineChart from "@/components/sales/LineChart.vue";
// const echarts = require('echarts');
export default {
    name:'Item',
    props:["item_info"],
    data(){
        return {
            xAxis_data:[],
            series_data:[]
        }
    },
    components:{
        LineChart
    },
    mounted(){
        this.drawLine();
    },

    methods:{
        formatNum(num){
            // num = String(num).replace(/(?<=\d)(?=(\d\d\d)+$)/g ,',');
            num = (num || 0).toString();
            let result = '';
            while (num.length > 3) {
                result = ',' + num.slice(-3) + result;
                num = num.slice(0, num.length - 3);
            }
            if (num) { result = num + result; }
            return result;
        },
        drawLine(){
            let item_info = JSON.parse(JSON.stringify(this.item_info))
            let data = item_info.data.sales_data.reverse();
            let xAxis_data = [];
            let series_data = [];
            data.forEach(item => {
                xAxis_data.push(item.date.slice(0,4)+'-'+item.date.slice(4));
                series_data.push(item.total_smart_sales);
            })
            this.xAxis_data = xAxis_data;
            this.series_data = series_data;
        },
        toDetail(info){
            if (info.rank_type){
                this.$emit("toDetail",info)
            }
        }
    }
}
</script>

<style scoped lang="less">
    tr{
        width: 100%;
        border-bottom: solid 1px #eff3f8;
        cursor: pointer;
        border-bottom: solid 1px #f5f5f5;
        &:hover{
            box-shadow: 0 0 5px 2px #edf2f3;
        }
        td{
            padding: 0 30px;
            text-align: center;
            vertical-align: middle;
            font-size: 16px;
            color: #333333;
            &.font_bold{
                font-weight: bold;
            }
            // &.td_hover{
            //     cursor: pointer;
            //     &:hover{
            //         color: #69a5f7;
            //     }
            // }
            &:last-child{
                padding-bottom: 10px;
            }
        }
        &.table_tr_1 td{
            font-size: 14px;
            color: #0d0d0d;
        }

        .td_flex{
            display: flex;
        }
        .td_color{
            width: 23px;
            height: 20px;
            border-radius: 5px 0 5px 0;
            margin: 0 10px;
        }
        &:nth-child(1) .td_color{
            background: #ba78d8;
        }
        &:nth-child(2) .td_color{
            background: #8b8bef;
        }
        &:nth-child(3) .td_color{
            background: #7bd7a9;
        }
        &:nth-child(4) .td_color{
            background: #f7b478;
        }
        &:nth-child(5) .td_color{
            background: #69a5f7;
        }
        &:nth-child(6) .td_color{
            background: #ef9bba;
        }
        &:nth-child(7) .td_color{
            background: #a2cefa;
        }
        &:nth-child(8) .td_color{
            background: #a2db9f;
        }
        &:nth-child(9) .td_color{
            background: #f6d78e;
        }
        &:nth-child(10) .td_color{
            background: #f1806a;
        }
        &:nth-child(11) .td_color{
            background: #b8bfc7;
        }
    }
    .td_chart{
        width: 320px;
        padding-right: 0;
        &.td_chart_1{
            width: 220px;
        }
    }
    .item_echart{
        width: 300px;
        height: 90px;
        &.item_echart_1{
            width: 200px;
            height: 80px;
        }
    }
    .ranking{
        font-size: 22px;
        font-weight: bold;
        color: #b1cae3;
        &.ranking1{
            width: 40px;
            height: 40px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank1_20230223.svg) no-repeat;
            background-size: 100%;
            margin: 0 auto;
        }
        &.ranking2{
            width: 40px;
            height: 40px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank2_20230223.svg) no-repeat;
            background-size: 100%;
            margin: 0 auto;
        }
        &.ranking3{
            width: 40px;
            height: 40px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/rank3_20230223.svg) no-repeat;
            background-size: 100%;
            margin: 0 auto;
        }
    }
    .rank_change{
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 16px;
        color: #333;
        .icon_up{
            width: 20px;
            height: 20px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/up_20230216.svg) no-repeat center center;
            background-size: 20px;
        }
        .icon_down{
            width: 20px;
            height: 20px;
            background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/change1/down_20230216.svg) no-repeat center center;
            background-size: 20px;
        }
    }
</style>